<template>
    <el-card  v-if="advanced.data" class="box-card">
        <div slot="header" class="clearfix">
            <span>Full settings list</span>
             <el-button style="margin-left:10px;" v-on:click="saveAdvanced()" size="mini" type="danger">Save advanced</el-button>
        </div>
        <div class="block">
            <el-row :gutter="5">
                <el-col :span="24">
                    <el-row :gutter="3">
                        <el-card class="box-card" id="recordVideo">
                            <div slot="header" class="clearfix">
                                <span>Distribution</span>
                            </div>
                            <div>
                                <el-col :span="24">
                                    <el-row>
                                        Deviation: <el-input-number id="videoInt" size="mini" v-model="advanced.data.deviation"></el-input-number>
                                    </el-row>
                                    <el-row>
                                        <div class="tip">
                                            Deviation
                                        </div>
                                    </el-row>
                                </el-col>
                            </div>
                        </el-card>
                        <el-card class="box-card" id="recordVideo">
                            <div slot="header" class="clearfix">
                                <span>Record video & state of anti-captcha</span>
                            </div>
                            <div>
                                <el-col :span="24">
                                    <el-row>
                                        Record each: <el-input-number id="videoInt" size="mini" v-model="advanced.data.video_ratio"></el-input-number>
                                    </el-row>
                                    <el-row>
                                        <div class="tip">
                                            Video recording option is measured in % where 0 - no videos at all.
                                        </div>
                                    </el-row>
                                </el-col>
                            </div>
                            <div>
                                <el-col :span="24">
                                    <el-row>
                                        Anticaptcha: 
                                        <el-switch
                                            v-model="advanced.data.anticaptcha"
                                            active-color="#13ce66"
                                            inactive-color="#ff4949">
                                        </el-switch>
                                    </el-row>
                                    <el-row>
                                        <div class="tip">
                                            It's just a boolean: you either want it or you don't.
                                        </div>
                                    </el-row>
                                </el-col>
                            </div>
                        </el-card>
                        <el-card class="box-card" id="recordVideo">
                            <div slot="header" class="clearfix">
                                <span>Number of retries</span>
                            </div>
                            <div>
                                <el-row>
                                    Retry num: <el-input-number id="videoInt" size="mini" v-model="advanced.data.retry_num"></el-input-number>
                                </el-row>
                                <el-row>
                                    <div class="tip">
                                        Desired number of retries from 0 to 5
                                    </div>
                                </el-row>
                            </div>
                        </el-card>
                        <el-card class="box-card" id="recordVideo">
                            <div slot="header" class="clearfix">
                                <span>Proxy project & browser version</span>
                            </div>
                            <div>
                                <el-row class="colSets">
                                    <el-col :span="1">
                                        ID
                                    </el-col>
                                    <el-col :span="3">
                                        <el-input id="videoInt" size="mini" v-model="advanced.data.proxy_project_id"></el-input>
                                    </el-col>
                                    <el-col id="browserTile" :span="3">
                                        Browser:
                                    </el-col>
                                    <el-col :span="6">
                                        <el-select id="firefox" v-model="advanced.data.browser"  size="mini" placeholder="Select mode">
                                            <el-option
                                            v-for="item in firefoxes"
                                            :key="item.value"
                                            :label="item.name"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col id="OS"  :span="2">
                                        OS:
                                    </el-col>
                                    <el-col :span="6">
                                        <el-select id="firefox" v-model="advanced.data.device_type"  size="mini" placeholder="Select OS">
                                            <el-option-group
                                            v-for="group in osTypes"
                                            :key="group.label"
                                            :label="group.label">
                                            <el-option
                                                v-for="item in group.options"
                                                :key="item.value"
                                                :label="item.name"
                                                :value="item.value">
                                            </el-option>
                                            </el-option-group>
                                        </el-select>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-tag
                                    v-for="tag in advanced.data.proxy_tags"
                                    :key="tag"
                                    closable
                                    @close="handleClose(tag)"
                                    >
                                    {{tag}}
                                    </el-tag>
                                </el-row>
                                <el-row>
                                    <el-col :span="6">
                                        <el-input v-model="tagInput"></el-input>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button @click="addTag()" type="danger">Add tag</el-button>
                                    </el-col>
                                    <el-col :span="12">
                                    </el-col>
                                </el-row>
                            </div>
                        </el-card>
                        <el-card class="box-card" id="recordVideo">
                            <div slot="header" class="clearfix">
                                <span>Reuse of profiles</span>
                            </div>
                            <div>
                                <el-row class="colSets">
                                    <el-col class="colTitle" :span="4">
                                        Usage cooldown:
                                    </el-col>
                                    <el-col :span="8">
                                        <el-input-number size="mini" :step="5" v-model="advanced.data.profile_usage_cooldown"></el-input-number>
                                    </el-col>
                                    <el-col class="colTitle" :span="4">
                                        Usage returning (%):
                                    </el-col>
                                    <el-col :span="4">
                                        <el-input-number size="mini" :min="0" :max="100" :step="5" v-model="advanced.data.profile_usage_returning"></el-input-number>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <div class="tip">
                                        <span><b>Cooldown:</b> how many days are supposed to pass before you can use those profiles again. </span>
                                        <span><b>Returning:</b> how many tasks (% of total) can ignore the cooldown parameter.</span>
                                    </div>
                                </el-row>
                            </div>
                        </el-card>
                         <el-card class="box-card" id="recordVideo">
                            <div slot="header" class="clearfix">
                                <span>Locale / Language</span>
                            </div>
                            <div>
                                <el-row class="colSets">
                                    <el-col class="colTitle" :span="5">
                                        Language code
                                    </el-col>
                                    <el-col :span="10">
                                         <el-input
                                            type="textarea"
                                            placeholder="Please input languages in ISO format"
                                            autosize
                                            v-model="language_codes">
                                        </el-input>
                                    </el-col>
                                    <el-col class="memo" :span="9">
                                        RU/EN/FR/IT/DE/ES
                                    </el-col>
                                </el-row>
                                <el-row :gutter="3" class="colSets">
                                    <el-col class="colTitle" :span="5">
                                        Country code
                                    </el-col>
                                    <el-col :span="10">
                                         <el-input
                                            type="textarea"
                                            placeholder="Please countries in ISO format"
                                            autosize
                                            v-model="country_codes">
                                        </el-input>
                                    </el-col>
                                    <el-col class="memo" :span="9">
                                        RU/EN/FR/IT/DE/ES
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <div class="tip">
                                        You can specify desired countries and languages in ISO format
                                    </div>
                                </el-row>
                            </div>
                        </el-card>
                    </el-row>
                    
                    <el-row :gutter="3">
                        <el-col :span="12">
                            
                        </el-col>
                        <el-col :span="12">
                        </el-col>
                    </el-row>
                </el-col>
                
            </el-row>
        </div>
    </el-card>

</template>
<style>
    #OS{
        padding-left:10px;
        
    }
    .colTitle{
        margin-top:5px;
    }
    #recordVideo {
        font-size: 14px;
    }
    #videoInt{
        margin-top:-5px;
    }
    .text {
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }

    .box-card {
        font-size:14px;
        width: 100%;
        margin-top:10px;
    }
    .advancedSettings {
        background-color:white;
        height:100%;
    }
    .asHeader {

    }
    .el-tag{
        margin:3px;
    }

    #browserTile{
        padding-left:15px;
    }

    .el-tag + .el-tag {
        margin-left: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
        margin-top:-15px !important;
    }
    #firefox{
        margin-top:-5px;
    }
    .memo{
        padding:5px;
    }
    .colSets{
        margin-top:5px;
    }     
    .el-tag + .el-tag {
    margin-left: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
    .el-row {
        padding-top:5px;
        padding-bottom:5px;
    }
</style>
<script>
export default {
    name: 'AdvancedSettings',
    computed: {
        includeTags: function () {
            if (this.advanced.data.include_tags.length)
                return this.advanced.data.include_tags;
            else 
                return [];
        },
        excludeTags: function () {
            if (this.advanced.data.exclude_tags.length)
                return this.advanced.data.exclude_tags;
            else 
                return [];
        },
    },
    mounted () {
    },
    props: {
        advanced: {
            type: Object,
            default: () => {}
        },
    },
    watch: {
        language_codes(newValue, oldValue) {
            this.advanced.data.language_codes = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        country_codes(newValue, oldValue) {
            this.advanced.data.country_codes = newValue.replace(/\r\n/g,"\n").split("\n");
        },
    },
    methods:{
        addTag() {
            if (this.tagInput.length) {
                this.advanced.data.proxy_tags.push(this.tagInput);
                this.tagInput = '';
            }
        },
        handleClose(tag) {
            this.advanced.data.proxy_tags.splice(this.advanced.data.proxy_tags.indexOf(tag), 1);

        },
        saveAdvanced() {
            var data = JSON.parse(JSON.stringify(this.advanced.data));
            //updateAdvanced
            var entity = this.advanced.data;
            if (entity.country_codes.length && entity.country_codes[0] == "") {
                entity.country_codes = [];
            }
            
            entity.project_id = this.$route.params.id;
            this.$store.dispatch('project/updateAdvanced', entity);
        },
        handleIncludeClose(tag) {
            this.includeTags.splice(this.includeTags.indexOf(tag), 1);
        },
        handleExcludeClose(tag) {
            this.excludeTags.splice(this.excludeTags.indexOf(tag), 1);
        },
        showIncludeInput() {
            this.inputIncludeVisible = true;
            this.$nextTick(_ => {
            this.$refs.saveTagInputInclude.$refs.input.focus();
            });
        },
        handleInputConfirmIncluded() {
            let inputValue = this.inputValueIncluded;
            if (inputValue) {
            this.includeTags.push(inputValue);
            }
            this.inputIncludeVisible = false;
            this.inputValueIncluded = '';
        },

        showExcludeInput() {
            this.inputExcludeVisible = true;
            this.$nextTick(_ => {
            this.$refs.saveTagInputExclude.$refs.input.focus();
            });
        },

        handleInputConfirmExcluded() {
            let inputValue = this.inputValueExcluded;
            if (inputValue) {
            this.excludeTags.push(inputValue);
            }
            this.inputExcludeVisible = false;
            this.inputValueExcluded = '';
        },
        getDefaultTableData() {
            return [
               
            ]
        },
        setChanged() {
            //compare with original
            this.hasChanged = true;
        },
        getLanguageCodes() {
            if (this.advanced.data.language_codes.length === 0) {
                return "";
            }

            return this.advanced.data.language_codes.join("\n");
        },
        getCountryCodes() {
            if (this.advanced.data.country_codes.length === 0) {
                return "";
            }

            return this.advanced.data.country_codes.join("\n");
        },
        handleClose(tag) {
            this.advanced.data.proxy_tags.splice(this.advanced.data.proxy_tags.indexOf(tag), 1);
        },
        
    },
    components:{

    },
     mounted: function () {
            this.language_codes =  this.getLanguageCodes(),
            this.country_codes = this.getCountryCodes(),
            this.settings =  this.$store.state.project.settings
            this.tags = JSON.parse(JSON.stringify(this.advanced.data.proxy_tags));
    },
    data() {
        return {
            tags:[],
            tagInput:'',
            language_codes: [],//this.getLanguageCodes(),
            country_codes: [],// this.getCountryCodes(),
            settings: [],//this.$store.state.project.settings,
            inputIncludeVisible: false,
            inputExcludeVisible: false,
            inputValueIncluded: '',
            inputValueExcluded: '',
            checked:false,
            video_ratio: 0,
            firefoxes: [
                {
                    name:'Firefox v115.5.0 Lopata Build',
                    value:'firefox115.5.0-lpt-build'
                },
                {
                    name:'Firefox v147.0.4 Lopata Build',
                    value:'firefox147.0.4-lpt-build'
                },
            ],
            osTypes: 
            [
                {
                    label: 'I don\t care',
                    options: 
                        [
                            {
                                name:'Any',
                                value:'any'
                            },
                        ]
                },
                {
                    label: 'Desktop systems',
                    options: 
                        [
                             {
                                name:'Any desktop',
                                value:'desktop_any'
                            },
                            {
                                name:'Windows',
                                value:'desktop_windows'
                            },
                            {
                                name:'MacOs',
                                value:'desktop_macos'
                            },
                            {
                                name:'Ubuntu',
                                value:'desktop_ubuntu'
                            },
                        ]
                }, 
                {
                    label: 'Mobile',
                    options: 
                        [
                            {
                                name:'Any mobile',
                                value:'mobile_any'
                            },
                            {
                                name:'iOS',
                                value:'mobile_ios'
                            },
                            {
                                name:'Android',
                                value:'mobile_android'
                            },
                            {
                                name:'Popka Test',
                                value:'mobile_popka'
                            },
                        ]
                },
            ],
        };
    }
}

</script>